var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.normalizedProductAvailability.length > 0)?_c('ul',{staticClass:"product-stock-debug"},_vm._l((_vm.normalizedProductAvailability),function(item,itemIndex){return _c('li',{key:`item-${itemIndex}`},[_vm._l((item),function(subItem){return _vm._l((subItem),function(value,propertyName){return _c('span',{key:`${propertyName}-${value}`,class:{
          highlighted:
            _vm.otcBranchName &&
            propertyName &&
            propertyName.toLowerCase().includes(_vm.otcBranchName),
        }},[_vm._v(_vm._s(propertyName)+":"),_c('strong',[_vm._v(_vm._s(value))])])})})],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }